// extracted by mini-css-extract-plugin
export default {"backdrop":"Sheet_backdrop__m3aV8","container":"Sheet_container__0edQB","container-visible":"Sheet_container-visible__WCO+i","close":"Sheet_close__+D1GS"};